import React, { useState } from 'react';
import hicon from '../../images/icon/magic.svg'
import { Fade } from "react-awesome-reveal";
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';

const FaqSection = (props) => {

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <section className="faq pb-140"  style={{background: "rgb(234, 238, 240)"}}>
            <div className="container">
                <div className="sec-title--two text-center mb-60">
                    <Fade direction='down' triggerOnce={'false'} duration={1000} delay={9}>
                        <div>
                            <div className="sub-title wow fadeInDown" data-wow-duration="600ms"><img
                                src={hicon} alt="" />FAQ’s</div>
                        </div>
                    </Fade>
                    <Fade direction='up' triggerOnce={'false'} duration={1200} delay={9}>
                        <div>
                            <h2 className="title wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">Have a question? Look here</h2>
                        </div>
                    </Fade>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="xb-faq wow fadeInUp" data-wow-delay="200ms" data-wow-duration="600ms">
                            <Accordion open={open} toggle={toggle} className='accordion_box clearfix list-unstyled'>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="1" className='acc-btn'><span className="number">01</span> _ How long does it take to build a custom software solution?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="1" className='acc_body'>
                                        <div className="content">
                                            <p>The timeline for custom software development varies depending on the complexity of the solution. Typically, it takes anywhere from 2 to 6 months to develop a scalable and tailored software solution. Factors like project size, integration requirements, and testing phases influence the timeline.</p>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="2" className='acc-btn'><span className="number">02</span> _ What technologies do you use to build software?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="2" className='acc_body'>
                                        <div className="content">
                                            <p>We use a variety of technologies to build robust and scalable software. Some of the key technologies include:</p>
                                            <ul className="list-unstyled">
                                                <li><i className="far fa-check"></i>Frontend: React.js, Angular, Vue.js</li>
                                                <li><i className="far fa-check"></i>Backend: Node.js, Django, Flask</li>
                                                <li><i className="far fa-check"></i>Database: MongoDB, PostgreSQL, MySQL</li>
                                                <li><i className="far fa-check"></i>Cloud: AWS, Azure, Google Cloud</li>
                                            </ul>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="3" className='acc-btn'><span className="number">03</span> _ Can you integrate third-party systems into my software?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="3" className='acc_body'>
                                        <div className="content">
                                            <p>Yes, we specialize in integrating third-party systems such as payment gateways, CRM tools, marketing platforms, and more. Our team ensures that your new software seamlessly connects with the tools you already use, creating a unified and efficient workflow.</p>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="4" className='acc-btn'><span className="number">04</span> _ How do you ensure the scalability of my software?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="4" className='acc_body'>
                                        <div className="content">
                                            <p>Scalability is a core principle in our development process. We design systems that can grow alongside your business by ensuring that the architecture is flexible, cloud-based, and capable of handling increasing users and data volumes without compromising performance.</p>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="5" className='acc-btn'><span className="number">05</span> _ Do you offer ongoing support after development?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="5" className='acc_body'>
                                        <div className="content">
                                            <p>Yes, we offer ongoing maintenance and support for all of our software solutions. This includes bug fixes, updates, performance monitoring, and adding new features as needed. Our team is always available to assist you in keeping your software running smoothly.</p>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default FaqSection;
